import { index } from 'd3'
import { fillString } from '@local_modules/generic/string-template.js'

import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'
import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'

import htmlTemplateIndex from './index.html'
import { showMenu } from './show-menu.js'

import { loadCurrenciesRates } from '../../../../helpers/app-data-loaders/load-currencies-rates.js'
import { updateView } from './update-view.js'
import { exportTableFeature } from './export/index.js'

/**
 *
 */
export async function showPageGroupIntercompanyTransactions (params) {
  console.log('showPageGroupIntercompanyTransactions')

  const { containerElementId, browserAppUser, browserAppAccount } = params

  if (!checkPageRestriction({ browserAppUser, browserAppAccount, allowPublic: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex
  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  document.title = ['Group Transactions:', browserAppAccount.data.appAccount.name].join(' ')

  // Set full height
  document.getElementById(containerElementId).classList.add('position-absolute')
  document.getElementById(containerElementId).classList.add('top-to-bottom')

  const [currenciesRates] = await Promise.all([
    loadCurrenciesRates()
  ])
  console.log('currenciesRates', currenciesRates)

  const context = {
    browserAppAccount,
    currenciesRates,
    currenciesCodeMap: index(browserAppAccount.data.currenciesForAccount, c => c.code),
    currenciesIdMap: index(browserAppAccount.data.currenciesForAccount, c => c.id)
  }

  console.log('context', context)

  showMenu(context)
  const gridApi = await updateView(context, true)

  const exportTableButtonElement = document.getElementById('exportTableButton')
  exportTableFeature(exportTableButtonElement, gridApi)

  return gridApi
}
